import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        ngModel: '=',
        ngDisabled: '=',
        ngChange: '&'
    },
    template: `
        <div
            ng-model="vm.ngModel"
            uib-timepicker
            class="timepicker"
            readonly-input="vm.ngDisabled"
            ng-disabled="vm.ngDisabled"
            ng-change="vm.ngChange()"
            show-spinners="false"
            show-meridian="ismeridian"
            show-seconds="false">
        </div>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/timepicker/index.js